import styled from 'styled-components';

export const AlertSection = styled.div`
    margin-bottom: 40px;
`;
